export const VALIDATION = {
	short_text: 200,
};

export { ITALIAN_REGIONS } from './regions';
